import { createForm } from '../../../factories'

export default createForm(['active', 'name', 'description', 'image', 'imageName', 'imageID'])



// WEBPACK FOOTER //
// ./src/store/modules/components/forms/update.js